import * as React from 'react';
import Flex, { Props as FlexProps } from '../Flex/Flex';
import Icon from '../Icon/Icon';
import Text from '../Text/Text';

export interface Props extends FlexProps {
  /** Name of the add-on. */
  addonName: string;
}

/** A common Bitrise footer component */
const AddonFooter: React.FunctionComponent<Props> = ({ addonName, ...rest }: Props) => (
  <Flex { ...rest } alignChildren="middle" direction="vertical">
    <Icon margin="x2" name="Bitbot" size="1.5rem" />
    <Text align="middle" letterSpacing="x5" size="x1" uppercase>
      { addonName }
    </Text>
    <Text align="middle" letterSpacing="x5" size="x1" uppercase>
      An Official Bitrise Add-on
    </Text>
  </Flex>
);

export default AddonFooter;
